import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'core-js/es/map';
import 'core-js/es/set';
import 'react-toastify/dist/ReactToastify.min.css';

ReactDOM.render(<App />, document.getElementById('root'));
